import React, { useEffect, useState } from "react";
import axios from "axios";
import { WebApiURL } from "../../Constants/Constants";

function ManageAccess() {
  const [users, setUsers] = useState([]);

  // Fetch users (only those with status = 0)
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${WebApiURL}Verification/Users`);
      const pendingUsers = res.data.filter((u) => u.status === 0);
      setUsers(pendingUsers);
    } catch (err) {
      console.error("Error fetching users:", err);
      alert("Failed to load users. Check console for details.");
    }
  };

  const handleAction = async (email, action) => {
    try {
      const url = `${WebApiURL}Verification/${action}/${email}`;
      console.log(`Calling API: ${url}`);
      const res = await axios.put(url);
      alert(res.data.message || `User ${action}d successfully.`);
      fetchUsers();
    } catch (err) {
      console.error(`Error performing ${action} on ${email}:`, err);
      const message = err.response?.data || "Something went wrong. Check console.";
      alert(`Error performing ${action}: ${message}`);
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return { text: "Approved", color: "green" };
      case -1:
        return { text: "Declined", color: "red" };
      default:
        return { text: "Pending", color: "blue" };
    }
  };

  return (
    <div className="container mt-4">
      <h2>User Management</h2>
      <table className="table table-bordered table-striped mt-3 align-middle">
        <thead>
          <tr>
            <th>Selected</th>
            <th>Full Name</th>
            <th>Surname</th>
            <th>Email</th>
            <th>Type of User</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user) => {
              const { text, color } = getStatusText(user.status);
              return (
                <tr key={user.email}>
                  <td><input type="checkbox" /></td>
                  <td>{user.fullName}</td>
                  <td>{user.surname}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td style={{ color, fontWeight: "bold" }}>{text}</td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => handleAction(user.email, "NormalApprove")}
                      >
                        Approve
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleAction(user.email, "NormalDecline")}
                      >
                        Decline
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                No users pending approval
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ManageAccess;
